import Super from './short-answer-review';
import classic from 'ember-classic-decorator';

@classic
export default class SharedQuestionnaireDropdownReview extends Super {}
